export default "__VITE_ASSET__1a3d5c9a__"